import { AdServerComponent } from "../../components";

export const AdServer = () => {
  return <AdServerComponent />;
};
